import { GetCommandOutput } from '@aws-sdk/lib-dynamodb';

// these are our actual user settings
export interface UserSettingsObject {
  version: number;
  assetColumns: string[];
  divisions: string[];
}

// this class is a nice wrapper that we use to parse the settings from the database, so that,
// as we add more settings for things, we just update all of the objects in-flight with the
// new key/value pairs. it also strips off the fields that we only use for the database
export class UserSettings implements UserSettingsObject {
  // we will increment this number when we make changes to the user settings
  public version: number;
  // for users that have access to the asset module, this will allow them to select which columns they want
  // to see in the asset table
  public assetColumns: string[];
  // allows the user to select which divisions they want to see content for
  public divisions: string[];

  constructor(data: GetCommandOutput['Item'] = {}) {
    this.version = data.version || 1;
    this.assetColumns = data.assetColumns || [];
    this.divisions = data.divisions || [];
  }
}

// this class is used to save the user settings to the database. it extends the UserSettings class
// it adds back the proper document_type and id fields that are required by the database
// and automatically increments the version number for us so we don't have to worry about it
export class UserSettingsDocument extends UserSettings {
  public readonly document_type = 'SETTINGS';
  public id: string;

  constructor(data: UserSettingsObject, id: string) {
    super(data);
    this.id = id;
    this.version = data.version + 1;
  }
}
